import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Compose from './Compose';
import Inbox from './Inbox';
import Sent from './Sent';
import MessageView from './MessageView';
import logo from '../pages/logo.png';
import './Messaging.css';

const Messaging = () => {
    const [currentView, setCurrentView] = useState('inbox');
    const [user, setUser] = useState(null);
    const [selectedMessageId, setSelectedMessageId] = useState(null);
    const navigate = useNavigate();
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
            } else {
                navigate('/login');
            }
        });

        return () => unsubscribe();
    }, [auth, navigate]);

    const handleMessageSelect = (messageId) => {
        setSelectedMessageId(messageId);
    };

    const handleBack = () => {
        setSelectedMessageId(null);
        setCurrentView('inbox');
    };

    const renderView = () => {
        if (selectedMessageId) {
            return <MessageView messageId={selectedMessageId} onBack={handleBack} />;
        }

        switch (currentView) {
            case 'inbox':
                return <Inbox user={user} onMessageSelect={handleMessageSelect} />;
            case 'sent':
                return <Sent user={user} onMessageSelect={handleMessageSelect} />;
            case 'compose':
                return <Compose user={user} onMessageSent={() => { setCurrentView('sent'); setSelectedMessageId(null); }} />;
            default:
                return <Inbox user={user} onMessageSelect={handleMessageSelect} />;
        }
    };

    const navigateTo = (view) => {
        setSelectedMessageId(null);
        setCurrentView(view);
    }

    return (
        <>
            <div className="top-nav">
                <div className="gmail-logo">
                    <img src={logo} alt="Holy See Bright Academy Logo" />
                </div>
                <div className="top-right-nav">
                    {user && <div className="user-profile">{user.email ? user.email.charAt(0).toUpperCase() : 'U'}</div>}
                </div>
            </div>
            <div className="main-container">
                <div className="left-sidebar">
                    <button className="compose-btn" onClick={() => navigateTo('compose')}>
                        <span className="material-icons">edit</span>
                        <span>Compose</span>
                    </button>

                    <ul className="sidebar-menu">
                        <li className={currentView === 'inbox' && !selectedMessageId ? 'active' : ''} onClick={() => navigateTo('inbox')}>
                            <span className="material-icons">inbox</span>
                            <span>Inbox</span>
                        </li>
                        <li className={currentView === 'sent' && !selectedMessageId ? 'active' : ''} onClick={() => navigateTo('sent')}>
                            <span className="material-icons">send</span>
                            <span>Sent</span>
                        </li>
                    </ul>
                </div>

                <div className="middle-section">
                    {user ? renderView() : <p>Loading...</p>}
                </div>
            </div>
        </>
    );
};

export default Messaging;
